/** Contact form service tiles — The Bridge- Wellness & Therapy Center */
export const BRIDGE_CONTACT_SERVICE_TILES: {
  value: string;
  label: string;
  iconClass: string;
}[] = [
  { value: 'premarital-counseling', label: 'Pre-marital counseling', iconClass: 'fas fa-heart' },
  { value: 'postmarital-counseling', label: 'Marriage & couples counseling', iconClass: 'fas fa-user-friends' },
  { value: 'counseling-1on1', label: 'Individual therapy', iconClass: 'fas fa-user' },
  { value: 'family-counseling', label: 'Family counseling', iconClass: 'fas fa-users' },
  { value: 'speaking-engagements', label: 'Workshops & speaking', iconClass: 'fas fa-microphone' },
  { value: 'not-sure', label: "I'm not sure yet", iconClass: 'fas fa-question-circle' },
];

export const BRIDGE_CONTACT_REFERRAL_OPTIONS: { value: string; label: string }[] = [
  { value: 'friend-family', label: 'Friend or family' },
  { value: 'google', label: 'Google search' },
  { value: 'social-media', label: 'Social media' },
  { value: 'professional-referral', label: 'Therapist or physician referral' },
  { value: 'church-community', label: 'Church or community' },
  { value: 'other', label: 'Other' },
];

/** @deprecated I-3 project name — use BRIDGE_CONTACT_* */
export const I3_CONTACT_SERVICE_TILES = BRIDGE_CONTACT_SERVICE_TILES;
/** @deprecated I-3 project name — use BRIDGE_CONTACT_* */
export const I3_CONTACT_REFERRAL_OPTIONS = BRIDGE_CONTACT_REFERRAL_OPTIONS;
